import { ref, onMounted, onUnmounted } from 'vue';

export function useShiftKey() {
  const isShiftPressed = ref(false);

  const onKeyDown = (e) => {
    if (e.key === 'Shift') {
      isShiftPressed.value = true;
    }
  };

  const onKeyUp = (e) => {
    if (e.key === 'Shift') {
      isShiftPressed.value = false;
    }
  };

  onMounted(() => {
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
  });

  onUnmounted(() => {
    window.removeEventListener('keydown', onKeyDown);
    window.removeEventListener('keyup', onKeyUp);
  });

  return {
    isShiftPressed,
  };
}